<ion-content>
  <div class="guest-wrapper">
    <div class="welcome-text">Welcome to</div>

    <div class="logo-container">
      <img src="https://storage.googleapis.com/nutritionambition.app/logos/login-screen-logo.svg" alt="Nutrition Ambition Logo" class="guest-logo" />
    </div>

    <div class="guest-card">
      <p class="tagline">Your personal nutrition assistant.</p>
      <p> Ready when you are.</p>
      <ion-button class="lets-go-btn" (click)="onLetsGo()">Let's go</ion-button>
    </div>

    <div class="copyright-text">
      Copyright &copy; 2025–{{ currentYear }} Nutrition Ambition All rights reserved
    </div>
  </div>
</ion-content>
